<template>
  <el-select
    :value="value"
    :placeholder="$t('placeholder.select')"
    :disabled="disabled"
    :loading="isLoadingRef"
    @change="handleChange"
  >
    <el-option
      v-for="item in currencyListRef"
      :key="item.code"
      :label="item.code"
      :value="item.code"
    />
  </el-select>
</template>

<script>
import { createComponent, ref, onMounted } from '@vue/composition-api'
import MarketplaceService from '../../api/marketplace'

const CurrencySelector = createComponent({
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isLoadingRef = ref(false)
    const currencyListRef = ref([])

    const getCurrencyList = async () => {
      isLoadingRef.value = true
      try {
        const { data: list } = await MarketplaceService.getCurrencyList()
        currencyListRef.value = list
      } finally {
        isLoadingRef.value = false
      }
    }

    const handleChange = (currencyCode) => {
      emit('input', currencyCode)
    }

    onMounted(() => {
      getCurrencyList()
    })

    return {
      isLoadingRef,
      currencyListRef,

      handleChange,
    }
  },
})
export default CurrencySelector
</script>
